import Api from '../../../shared/Api';
import {
    IEdit,
    ISpecialAuthorizationsGroup,
    ICreateSpecialAuthorizationLinkCommand
} from './Types';

class SpecialAuthorizationsApi {
    static edit(id: number): Promise<any> {
        return new Promise<any>(
            (resolve: (response: IEdit) => void, reject: (error: any) => void) => {
                new Api()
                    .get(`/views/specialauthorizations/${id}/edit`)
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static update(userId: number, value: any): Promise<any> {
        return new Promise<any>(
            (resolve: (response: any) => void, reject: (error: string) => void) => {
                new Api()
                    .put(`/views/specialauthorizations/${userId}`, value)
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }
}

export default SpecialAuthorizationsApi;
